'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    theme: {
        borderGradient: {
            DEFAULT: 'linear-gradient(195.41deg, var(--tw-gradient-stops))',
            'to-t': 'linear-gradient(to top, var(--tw-gradient-stops))',
            'to-tr': 'linear-gradient(to top right, var(--tw-gradient-stops))',
            'to-r': 'linear-gradient(to right, var(--tw-gradient-stops))',
            'to-br': 'linear-gradient(to bottom right, var(--tw-gradient-stops))',
            'to-b': 'linear-gradient(to bottom, var(--tw-gradient-stops))',
            'to-bl': 'linear-gradient(to bottom left, var(--tw-gradient-stops))',
            'to-l': 'linear-gradient(to left, var(--tw-gradient-stops))',
            'to-tl': 'linear-gradient(to top left, var(--tw-gradient-stops))'
        }
    }
};

exports.default = preset;
//# sourceMappingURL=gradient.js.map
